export default {
  id: "timeSeriesUnitsSold",
  name: "",
  description: "",
  report: {
    name: "Daily Units Sold",
    chartType: "LINE",
    template: "custom",
    config: {
      dataType: "time_series",
      dataSet: "SaleItem",
      dimensions: [],
      measures: ["SaleItem.units_sold"],
      sort: {
        direction: null,
        by: null,
      },
      filters: [],
      compare: true,
      limit: "100",
      rowTotals: false,
      stacked: false,
      points: false,
      colorTheme: "default",
    },
  },
};
